module.exports = __webpack_public_path__ + "static/mwjwinterbaileyathhroadsign-f3e5da1ec31dbd8caebcec80541db658.jpg";